<template>
  <MainNavbar class="edu-fixed-nav" />
  <PaymentManual />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PaymentManual from "@/components/Payment/PaymentManual.vue";

export default defineComponent({
  name: "PaymentPage",
  components: {
    MainNavbar,
    PaymentManual,
  },
});
</script>
